import helper from '../helper'

export const serviceTAffiliate = {
  get: (token, params) => helper.get('api/v1/transaction-affiliates', token, params),
  info: (token, params) => helper.get('api/v1/transaction-affiliates/info', token, params)
}
